module.exports = __webpack_public_path__ + "img/money_back_icon.dee0fb02.png";